import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { HonestTimePickerInput } from 'components/HonestTimePicker/HonestTimePickerInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { absenceList } from './shiftsData'
import { ISelectValue } from 'constants/globalTypes'
import { addShift, editShift } from 'features/shifts/shiftsSlice'

export const ShiftsModal = ({ closeModal, value }: { closeModal: any, value?: IShiftModal }) => {
    const [state, setState] = useState<IShiftModal>(value || {
        name: '',
        info: '',
        color: '#ff9900',
        absenceType: {
            value: 6,
            label: 'Active'
        },
        range: {
            shiftStart: 480,
            minutes: 540,
            minutesSelected: false,
            startSelected: false
        }
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const invalid = (!state.name || !state.info || !state.absenceType?.value || (state.absenceType.value == 6 && (!state.range.minutesSelected || !state.range.startSelected)))

    const handleSave = async () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const resp = await dispatch(value?.id ? editShift(state) : addShift(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleTimeChange = (time: string, name: string) => {
        const splitted = time.split(':')
        const minutes = parseInt(splitted[0]) * 60 + parseInt(splitted[1])
        if (name == 'shiftStart') {
            setState((prev) => {
                const copy = { ...prev }
                return { ...copy, range: { ...copy.range, shiftStart: minutes, startSelected: true } }
            })
        } else {
            setState((prev) => {
                const copy = { ...prev }
                if (minutes > copy.range.shiftStart) {
                    return { ...copy, range: { ...copy.range, minutes: minutes - copy.range.shiftStart, minutesSelected: true } }
                } else {
                    return { ...copy, range: { ...copy.range, minutes: 1440 - copy.range.shiftStart + minutes, minutesSelected: true } }
                }
            })
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setState(prev => ({ ...prev, [name]: value }))
    }

    const handleSelect = (value: ISelectValue) => {
        setState(prev => ({ ...prev, absenceType: value }))
    }

    return <Modal black>
        <Flex column between center gap='1rem' >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Shift</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input invalid={!state.name} placeholder='Morning shift' labelText='Shift name' value={state.name} onChange={handleChange} nomarg name='name' />
                <HonestSelectInput
                    options={absenceList}
                    labelText='Type'
                    nomarg
                    onChange={handleSelect}
                    defaultValue={state.absenceType?.value}
                    invalid={!state.absenceType}
                />
                {state.absenceType?.value == 6 && <Flex gap='2rem' >
                    <HonestTimePickerInput
                        labelText='From'
                        onChange={(time) => handleTimeChange(time, 'shiftStart')}
                        defaultValue={state ? state.range.shiftStart : null}
                    />
                    <HonestTimePickerInput
                        labelText='To'
                        onChange={(time) => handleTimeChange(time, 'minutes')}
                        defaultValue={state ? state.range.minutes : null}
                        calculated={state.range.shiftStart}
                    />
                </Flex>}
                <Input height='150px' placeholder='Enter description' labelText='Shift description (optional)' value={state.info} onChange={handleChange} nomarg name='info' type='textarea' />
                <Input labelText='Color' value={state.color || '#ff9900'} onChange={handleChange} nomarg name='color' type='color' />
            </Flex>
            <Button disabled={invalid} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IShiftModal {
    id?: number
    name: string
    info: string
    color?: string
    absenceType: ISelectValue
    range: {
        shiftStart: number
        minutes: number
        minutesSelected: boolean
        startSelected: boolean
    }
}